import React from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';
import {useTheme} from "@mui/material";

export default function ExpandMoreIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
    return (
        <SvgIcon
            {...props}
            color={color}
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 24 24"
            xmlSpace="preserve"
            enableBackground="new 0 0 24 24"
            titleAccess="ExapandMore"
            fill="none"
            fontSize={'small'}
        >
            <path
                d="M4 8L12 16L20 8"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{fill: 'none'}}
            />
        </SvgIcon>
    );
}
